import {LangKeys} from "locales/i18n";

export default {
   [LangKeys.en]: {
       title: "Guidelines | Pumpkin Meet",
       description: "",
   },
}